import { Box } from '@mui/material';
import { CasMultiSelect, ICasMultiSelect } from 'src/compass/shared/components';
import { useRetrieveSelectListOptions } from 'src/compass/shared/components/CasSelect/CasEntitySelect';

// Direct path: importing from src/compass/application would be a self-import cycle.
import CasTagChip, { ICasTag } from './CasTagChip';

const entity = 'Tag';
const activeOnlyParams = { isActive: true };

export function CasTagMultiSelect(props: Omit<ICasMultiSelect, 'options'>) {
  const { mode, value } = props;
  const { options, isLoading } = useRetrieveSelectListOptions(entity, {
    ...props,
    params: activeOnlyParams,
  });

  // The filter chip (CasFilterChips) renders this in display mode: the selected tags, each in its
  // own color, rather than CasMultiSelect's plain "New, Watch".
  if (mode === 'display') {
    const ids = Array.isArray(value) ? value : [];
    const selected = (options as ICasTag[]).filter((o) => ids.includes(o.id));
    return (
      <Box component="span" sx={{ display: 'inline-flex', gap: 0.5, verticalAlign: 'middle' }}>
        {selected.map((tag) => (
          <CasTagChip key={tag.id} tag={tag} />
        ))}
      </Box>
    );
  }

  // props first: this wrapper owns `options`, so a caller-passed (or undefined)
  // options must not clobber the fetched list.
  return (
    <CasMultiSelect
      {...props}
      options={options}
      loading={isLoading}
      // Each tag in its own color, in the list and once selected.
      renderOption={(rProps, option: ICasTag) => (
        <li {...rProps} key={option.id}>
          <CasTagChip tag={option} />
        </li>
      )}
      renderTags={(selected: ICasTag[], getTagProps) =>
        selected.map((option, index) => (
          <CasTagChip {...getTagProps({ index })} key={option.id} tag={option} />
        ))
      }
    />
  );
}
